import { useBlockSize } from '@/shared/hooks/use-block-size';
import { RefObject } from 'react';
import {
	BOLD_LINE_INDEX,
	LINE_GAP,
	WATER_MARKS_HORIZONTAL_COUNT,
	WATER_MARKS_VERTICAL_COUNT,
} from '../constants/editor.constants';
import { WaterMark } from '../types/editor.types';

export const useEditorNet = (editorRef: RefObject<HTMLDivElement>) => {
	const editorSize = useBlockSize(editorRef);

	const horizontalLinesCount = Math.floor(editorSize.height / LINE_GAP);
	const verticalLinesCount = Math.floor(editorSize.width / LINE_GAP);

	const horizontalLinesGap = editorSize.height / horizontalLinesCount;
	const verticalLinesGap = editorSize.width / verticalLinesCount;

	const horizontalLines = Array.from({ length: horizontalLinesCount }).map((_, index) => ({
		bold: index % BOLD_LINE_INDEX === 0,
		top: index * horizontalLinesGap,
		key: index,
	}));
	const verticalLines = Array.from({ length: verticalLinesCount }).map((_, index) => ({
		bold: index % BOLD_LINE_INDEX === 0,
		left: index * verticalLinesGap,
		key: index,
	}));

	const horizontalWaterMarksGap = editorSize.height / WATER_MARKS_HORIZONTAL_COUNT;
	const verticalWaterMarksGap = editorSize.width / WATER_MARKS_VERTICAL_COUNT;

	const waterMarks = (() => {
		const waterMarks: WaterMark[] = [];

		for (
			let horizontalIndex = 0;
			horizontalIndex < WATER_MARKS_HORIZONTAL_COUNT;
			horizontalIndex++
		) {
			for (
				let verticalIndex = 0;
				verticalIndex < WATER_MARKS_VERTICAL_COUNT;
				verticalIndex++
			) {
				if ((horizontalIndex + verticalIndex) % 2 === 0) continue;

				waterMarks.push({
					key: `${horizontalIndex}-${verticalIndex}`,
					top: horizontalIndex * horizontalWaterMarksGap + horizontalWaterMarksGap / 2,
					left: verticalIndex * verticalWaterMarksGap + verticalWaterMarksGap / 2,
				});
			}
		}

		return waterMarks;
	})();

	return {
		horizontalLines,
		verticalLines,
		waterMarks,
	};
};
